/** @jsx jsx */
import { jsx } from '@emotion/core'
import { styles } from './style'
import { useEffect, useState } from 'react'
import { getBanners } from '../././../../sources/slot-finder'
import { raiseGAEventForSlotFinder } from '../../../utils/network'

export default function DisplayBanners(props) {
  const [banners, setBanners] = useState(null)
  const [inViewIndex, setInViewIndex] = useState(0)
  useEffect(() => {
    (async function getBanner() {
      try {
        const promoBanners = await getBanners()
        const { banners = [] } = promoBanners
        setBanners(banners)
      } catch (e) {
        console.log(e)
      }
    })()
  }, [])

  const onClick = (banner = {}) => {
    const { ActionWebURL = '', BannerName = '' } = banner
    raiseGAEventForSlotFinder({ eventAction: 'Banner', eventLabel: BannerName })
    window.open(ActionWebURL, '_self')
  }

  function scrollhandler(banners) {
    banners.forEach((element, index) => {
      if (isInViewport(document.getElementById(`banner-${index}`))) {
        setInViewIndex(index)
      }
    })
  }

  function automaticScroll() {
    let element = 0
    let lengthOfScrollableElement = banners.length || 1
    setInterval(() => {
      element = Math.floor((1 + element) % lengthOfScrollableElement)
      const scrollableContainer = document.getElementById(`box`) || null
      if(scrollableContainer) {scrollableContainer.scrollLeft = document.getElementById(`banner-${element}`)?.offsetLeft - 8}
    }, 3000)
  }

  return (
    <div css={styles.promoContainer}>
      <div
        css={{ ...styles.scrollmenu, scrollBehavior: banners && inViewIndex == banners.length - 1 ? 'auto' : 'smooth' }}
        id='box'
        onScroll={scrollhandler.bind(props, banners)}
        onLoad={automaticScroll} >
        {banners && banners.map((banner, index) => {
          return (
            <img
              key={`${index}-banner`}
              id={`banner-${index}`}
              src={banner.BannerImageURL}
              css={styles.cardImg((index === banners.length - 1))}
              onClick={onClick.bind(props, banner)} />
          )
        })}
      </div>
      <div css={styles.carouselContainer}>
        {banners && banners.length > 1 && banners.map((element, index) => (
          <div
            key={`corousel-${index}`} css={styles.carouselElement(inViewIndex == index)} />
        ))}
      </div>
    </div>
  )
}

function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)

  );
}